import jsPDF from "jspdf";
import HecoAnalyticsLogo from "../../images/HecoAnalyticsLogo.png";

export const generateTextReportPDF = (
  companyName,
  timestamp,
textReportHeader
) => {
  try {
    if (!Array.isArray(textReportHeader) || textReportHeader.length === 0) {
      throw new Error("No report data available.");
    }

    // Create a new instance of jsPDF
    const doc = new jsPDF();

    // setting initial values
    doc.setFontSize(12);
    doc.setTextColor(0, 0, 0);

    const leftMargin = 15;
    const rightMargin = doc.internal.pageSize.getWidth() - 10;
    const pageHeight = doc.internal.pageSize.getHeight();

    doc.setFont("helvetica", "italic");
    doc.text("Report generated on: " + timestamp, leftMargin, 10);

    doc.setFont("helvetica", "normal");
    doc.text("Dear " + companyName + ",", leftMargin, 25);

    doc.text(
      "Thank you for completing the HecoAnalytics form.",
      leftMargin,
      40
    );

let y_position = 60;
let currentPage = 1;

const contentLines = [];

textReportHeader.forEach(item => {
  const reportData = item.reportData ;
  const dataLines = reportData.split('. ');
  contentLines.push(...dataLines);
});

const content = contentLines.join(" ");

const textLines = doc.splitTextToSize(content, rightMargin - leftMargin);

// Iterate through the lines
textLines.forEach((line, lineIndex) => {
  if (y_position + 20 > pageHeight) {
    doc.addPage();
    currentPage++;
    y_position = 20;
  }

  doc.text(line, leftMargin, y_position);

  if (lineIndex < textLines.length - 1) {
    y_position += 5;
  } else {
    y_position += 10;
  }
});


    doc.text(
      "You can resubmit a form at any time and generate an updated report.",
      leftMargin,
      y_position
    );
    y_position += 20;

    doc.text("Best,", leftMargin, y_position);
    doc.text("The Heco Analytics Team", leftMargin, y_position + 5);

    doc.addImage(HecoAnalyticsLogo, "PNG", leftMargin, y_position + 15, 25, 10);

    return doc;
  } catch (error) {
    console.error("Error generating PDF:", error);
    throw error;
  }
};
